// JavaScript Document
//Ph5 Configuration
//components/configuration/ph5/Config.js
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
//import Schedule from './tabs/Schedule';
//import Events from './tabs/Events';
//import Messages from './tabs/Messages';
//import Advanced from './tabs/Advanced';
//import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Save';
import Tooltip from '@material-ui/core/Tooltip';

//import dsutils from './daysettings/Utils';
import Messages from './Messages';
//import Display from '../display/Display';
import Field from './setting/Field';
import Utils from './Utils';
//import Field from './Field';

//import ImagePicker from '../forms/ImagePicker';
//import TextArea from '@material-ui/core/TextareaAutosize';
//import Display from '../../display/Display';
//import Paper from '@material-ui/core/Paper';
const utils = Utils();

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}//`

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
	root: {
    	flexGrow: 1,
    	width: '100%',
	  	backgroundColor: theme.palette.background.default,
  	},
	configHeader: {
		display: "flex",
		flexGrow: 1,
		flexDirection: 'row',
		marginTop: theme.spacing(1),
		marginLeft: theme.spacing(1)
	},
	nameDescription: {
		display: "flex",
		flexGrow: 1,
		flexDirection: 'column'
	},
	saveButton: {
		margin: theme.spacing(1),
	},
  	tabContent : {
	  	flexGrow: 1,
	  	width: '100%',
	  	backgroundColor: theme.palette.background.paper,
  	},
	discreetInput : {
		transition: theme.transitions.create(['border-color', 'box-shadow']),
		'&:hover':{
			backgroundColor:theme.palette.background.paper
		}
	},
	largeFont : {
		fontSize: '1.3em',
		fontWeight: 'bold'
	},
	pos: {
		marginBottom:12,
	},
}));

export default function Config(props) {
  	const classes = useStyles();
	const {sign, handleSend, user} = props;
	const [config, setConfig] = React.useState([]);
	const [signId, setSignId] = React.useState(0);
	const [messages, setMessages] = React.useState([]);
  	const [value, setValue] = React.useState(0);
	const [loaded, setLoaded] = React.useState(false);
	const [userChanged, setUserChanged] = React.useState(false);
	const [saveLabel, setSaveLabel] = React.useState('Save');
	//const [loadedToken, setLoadedToken] = React.useState(Date.now());
	//const [displays, setDisplays] = React.useState({});
	/*
	const [config, setConfig] = React.useState(
		{
			daysettings : {
				"0" : utils.model.daysetting
			},
			name: 'Configuration',
			description: 'loading...',
			special_events: [],
			sunday : 0,
			monday : 0,
			tuesday : 0,
			wednesday : 0,
			thursday : 0,
			friday : 0,
			saturday : 0,
			pixel_maps : {}
		}
	);
	*/
	//Refresh load
	React.useEffect(() => {
		if(sign.id 
		  && sign.id !== signId){
			setSignId(sign.id);
			setLoaded(false);
			//if(sign.ph5_settings)
			//	if(sign.ph5_settings.length > 0)
			//		setConfig(sign.ph5_settings);
		}
		if(!loaded){
			getConfig();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props]);
	
	
	//update config
	const handleUpdateConfig = (newConfig) => {
		setConfig(newConfig);
		setUserChanged(true);
	}
	const handleChangeValue = (e) => {
		var newConfig = Object.assign([], config);
		let name = e.target.name;
		let value = e.target.value;
		//assign the value
		console.log(name+" = "+value);
		newConfig[newConfig.findIndex(item => item.name === name)].value = value;
		handleUpdateConfig(newConfig);
		//setConfig(newConfig);
	}
	
	/*
	//handle basic value change
	const handleChangeBase = (e) => {
		let name = e.target.name;
		let value = e.target.value;
		let newConfig = Object.assign({}, config);
		newConfig[name]=value;
		handleUpdateConfig(newConfig);
	}
	*/
	
	
	
  	//load config from server
  	const getConfig = () =>{
	  	setLoaded(true);
	  	handleSend({
		  	vso: 'ph5_config',
			sign: sign
	  	}, (data) => {
		  	setConfig(data.config.settings);
			setMessages(data.config.messages);
			//setDisplays(renderDisplays(data.config.pixel_maps));
		  	console.log(data.config);
			//setLoadedToken(Date.now());
		});
  	}
	
	
	//Change selected tab
  	const handleChange = (event, newValue) => {
    	setValue(newValue);
  	};
	
	const handleChangeMessages = (msgs) => {
		setMessages(msgs);
		console.log(msgs);
		setUserChanged(true);
	}
	
	//Handle save action
	const handleSave = (e) => {
		setSaveLabel('Saving');
		console.log("Save button clicked!");
		handleSend({
			vso: 'ph5_config',
			config: {
				settings: config,
				messages: messages,
			},
			sign: sign,
			subaction: 'save'
		}, (data) => {
			console.log(data);
			setUserChanged(false);
			setSaveLabel('Save');
			setConfig(data.config.settings);
			setMessages(data.config.messages);
			
		});
	}
	/*
	const renderDisplay = (pmap) => {
		if(pmap){
			return (
				<Display 
					id={pmap.id} 
					scale={2} 
					splitVertical={3} 
					width={30} 
					height={18} 
					pixel_map={pmap.pixel_map}
					borderSize="5"
				/>
			);
		} else {
			return (
				<Display
					id={0}
					scale={2}
					splitVertical={3}
					width={30}
					height={18}
					borderSize="5"
					pixel_map={Array(18).fill('0'.repeat(30)).join(',')}
				/>
			);
		}
	};
	*/
	/*
	const renderDisplays = (pmaps) => {
		var myDisplays = {};
		for(var n in pmaps){
			myDisplays[n] = renderDisplay(pmaps[n]);
		}
		myDisplays[0] = renderDisplay();
		return myDisplays;
		0:DEMO, 1:DELTA, 2:CALTRAN, 3:RAMP/ECO, 4:SPEED, 5:CYCLE12, 6:CYCLE34, 7:SCALES, 8:REMOTE, 9:MODE, 10:CALTRAN10, 11:USER SEQUENCE, 12:USER SPEED, 13:SIGNAL AHEAD, 14:SPEED TS2, 15:SPEED DISPLAY, 16:SPEED SEQUENCE, 17:DELTA NORDEL 25: SPEED 2, 40:FTI_DEMO
	};
	*/
	const renderField = (item) => {
		let options = {};
		if(item.input_control)
			if(item.control_setup)
				if(typeof item.control_setup === 'string')
					options = JSON.parse(item.control_setup);
		return (
			<Grid item xs={12} sm={6} md={4}>
				<Field
					id={"ph5_config_"+item.id}
					name={item.name}
					label={item.description ? item.description : item.name}
					choices={item.options ? utils.extractChoices(item.options) : []}
					options={options}
					control={item.input_control}
					value={item.value}
					onChange={handleChangeValue}
				/>
			</Grid>
		);
	}
	const renderFieldItem = (item) => {
		if(item.input_description)
			return (
				<Tooltip title={item.input_description} arrow>{renderField(item)}</Tooltip>
			);
		return renderField(item);
	}
	//renders the save button if changes have been made
	const renderSave = () => {
		if(userChanged){
			return (
				<Button 
					variant="contained" 
					color="secondary" 
					onClick={handleSave} 
					endIcon={<SaveIcon />}
					className={classes.saveButton}
					size="large"
					disabled={saveLabel==='Saving' ? true : false}
				>
					{saveLabel}
				</Button>
			);
		}
		return "";
	}
	
  	return (
    	<div className={classes.root}>
			<Box className={classes.configHeader}>
				<Box className={classes.nameDescription}>
					<Typography variant="h5" gutterBottom>
							{sign.location}
	  				</Typography>
	  				<Typography variant="body2" gutterBottom>
	  		  	  			{sign.description}
	  				</Typography>
				</Box>
				{renderSave()}
			</Box>
      	<AppBar position="static" color="default">
        	<Tabs
          		value={value}
          		onChange={handleChange}
          		indicatorColor="primary"
          		textColor="primary"
          		variant="scrollable"
          		scrollButtons="auto"
          		aria-label="scrollable auto tabs example"
        	>
          		<Tab label="Details" {...a11yProps(0)} />
          		<Tab label="Messages" {...a11yProps(1)} />
        	</Tabs>
      	</AppBar>
      	<TabPanel value={value} index={0} className={classes.tabContent}>
        	<Grid container spacing={3}>
				{config.map((item, i) => (
				renderFieldItem(item)
				))}
			</Grid>
      	</TabPanel>
      	<TabPanel value={value} index={1} className={classes.tabContent}>
			<Messages sign={sign} config={config} user={user} messages={messages} handleSend={handleSend} onChange={handleChangeMessages} />
`		</TabPanel>`
    </div>
  );
}
